export const capitalizeFirstChar = (str) => {
  if (str && str.length > 1) {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  }
  return str;
};

export const extractImages = (jsonData) => {
  // Initialize an empty array to store image URLs
  let imageArray = [];

  // Loop through each slide in the JSON data
  jsonData.forEach((slide) => {
    // Loop through each section in the slide
    slide.sections.forEach((section) => {
      // Check if the section contains an image
      if (section.hasOwnProperty("image")) {
        // Add the image URL to the array
        imageArray.push(section.image);
      }
    });
  });

  // Return the array of image URLs
  return imageArray;
};
